const TITLE_MARGIN = 20;
const TITLE_WIDTH = 215;
const STEP_MARGIN = 20;
const SEPARATOR_WIDTH = 100;

export { STEP_MARGIN, TITLE_MARGIN, TITLE_WIDTH, SEPARATOR_WIDTH };
